import React from 'react';
import PropTypes from 'prop-types';

import Label from "./Label";
import Configuration from "../../Configuration";

/**
 * Component representing an input control.
 */
class Input extends React.Component
{
    static propTypes = {
        // The input label. Not integrated if not passed.
        label: PropTypes.string,

        // The input type
        type: PropTypes.oneOf(["text", "number", "date"]),
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),

        // The minimum allowed value (only for type number)
        min: PropTypes.number,

        // The maximum allowed value (only for type number)
        max: PropTypes.number,

        // Disable or enable the input
        disabled: PropTypes.bool,

        // Triggered when the input value change
        onChange: PropTypes.func
    };

    static defaultProps = {
        type: "text",
        value: "",
        disabled: false
    };

    state = {
        value: this.props.value
    };

    /**
     * Triggered when the input value change.
     *
     * @param e The input event object
     */
    onChange = e => {
        const {type, min, max, onChange} = this.props;
        let value = e.currentTarget.value;

        if (type === 'number') {
            // Restrict one figure after the comma
            const splitValue = value.split('.');
            value = splitValue[0];

            if (splitValue.length > 1) {
                value += '.' + splitValue[1].substring(0, 1);
            }

            value = isNaN(value) ? this.state.value : parseFloat(value, 10);

            // Round float value 1 figure after the comma
            const factor = Math.pow(10, 1);
            value = Math.round(value * factor) / factor;

            if (min && value < min) {
                value = min;
            } else if (max && value > max) {
                value = max;
            }
        }

        if (isNaN(value)) {
            value = 0;
        }

        this.setState({value});

        onChange && onChange(value);
    };

    render() {
        const {label, name, type} = this.props;
        const {value} = this.state;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        return (
            <React.Fragment>
                <Label className="text-center" htmlFor={name}>{label}</Label>

                <input className={client} name={name} type={type} value={value === 0 ? '' : value} onChange={this.onChange} />
            </React.Fragment>
        )
    }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/widgets/Input.js